import { GridFieldAuthorization } from './../../../../../../models/administration/securityLevel';
import {
  Component,
  ElementRef,
  HostListener,
  Inject,
  Injector,
  OnDestroy,
  OnInit,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import {
    FormBuilder,
    FormControl,
    FormGroup,
    Validators
} from '@angular/forms';
import { ComboBoxComponent } from '@progress/kendo-angular-dropdowns';
import { GridComponent } from '@progress/kendo-angular-grid';
import { TabPosition } from '@progress/kendo-angular-layout';
import { groupBy, GroupResult } from '@progress/kendo-data-query';
import { MobileAppGroupSummary } from '~/models/administration/mobileAppGroup';
import { SecurityLevelSummary } from '~/models/administration/securityLevel';
import { GridFieldDefinition } from '~/models/modules/GridFieldText';
import { AppRolesService } from '~/services/administration.ts/approles';
import { SharedService } from '~/services/sharedService';
import { ThemeManagerService } from '~/services/theme-manager';
import { GridLayoutManagerService } from '~/shared/components/grid/layout/grid-layout-manager';
import { LayoutManagerService, PORTAL_DATA } from '~/shared/components/layout/layout-manager';
import { LayoutComponent } from '~/shared/components/layout/layout.component';
import { PageState } from '~/shared/enums/stock-files.enum';
import { title } from 'process';
import { PermissionsService } from '~/services/administration.ts/permissions.service';
import { Subscription, forkJoin } from 'rxjs';
import { PermissionDto } from '~/models/administration/permission';

@Component({
    selector: 'app-security-level-upsert',
    templateUrl: './upsert.html',
    styleUrls: ['./upsert.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class SecurityLevelUpsertComponent implements OnInit, OnDestroy {
  _permissionSub!: Subscription;
  _permissionsList: PermissionDto[];
  _authrizationSub!: Subscription;
  _kendoTabStripPosition: TabPosition = 'left';
  _innerWidth: any;
  _hiddenWindow: any;
  _maximized: any;
  _theme: string;
  // _isNew: boolean;
  _form: FormGroup;
  _active: boolean;
  _isAutoGeneratingNumber: boolean;
  _tabEnabled: boolean;
  _currentType: string;
  _invalidForm: boolean;
  _model: SecurityLevelSummary;
  _pageState: PageState;
  appRoleId: number = 2;
  moduleId: number = 1;
  _defaultAppRoles: Array<number> = [1, 2, 3, 4, 5, 6, 7, 8];
  _generalSecurityLevelsStockGridData: any[] = [];
  _stockSecurityLevelsStockGridData: any[] = [];
  _AssetsSecurityLevelsStockGridData: any[] = [];
  _generalGroupedData: GroupResult[] = [];
  _stockGroupedData: GroupResult[] = [];
  _assetGroupedData: GroupResult[] = [];

  _appRoles: any[];
  _appRolesFiltered: any[];
  _selectedAppRole = new FormControl();
  _isDialiog: boolean = false;
  _dialogComponentName: string;
  _dialogModel: any;
  _scrollable: boolean;
  _maxHeight: number;

  @ViewChild('kendo_tabstrip_wrapper') navTrigger: ElementRef;
  @ViewChild('Kendo_Combobox_AppRole') kendoComboboxAppRole: ComboBoxComponent;
  @ViewChild('gridWrapper') gridWrapper: ElementRef;
  @ViewChild('grid') grid: GridComponent;
  @ViewChild('grid_header_wrapper') gridHeaderWrapper: ElementRef;

    constructor(
        private _appRolesService: AppRolesService,
        private _fb: FormBuilder,
        private _themeManager: ThemeManagerService,
        private _layoutManager: LayoutManagerService,
        private _layoutComponent: LayoutComponent,
        private _gridLayoutManagerService: GridLayoutManagerService,
        private _sharedService: SharedService,
        private _permissionService: PermissionsService
    ) {
        if (this._sharedService.model) {
          this._model = this._sharedService.model.model;
              if (this._model.id) {
              this.appRoleId = this._model.id;
              }
              const tab = {
                  title: 'General'
              };
              this._onTabSelect(tab);
          this._active = true;
          this._pageState = this._sharedService.model.pageState;
        }
        this._themeManager.themeChange.subscribe((data) => {
            this._theme = data;
        });
         this._layoutManager.applyOverly();

    }

    ngOnInit() {
        this._initForm();
        setTimeout(() => {
          this._initScrollable();
        });
    }

  _initScrollable() {
    let topHeight = this.gridHeaderWrapper?.nativeElement.clientHeight + 105;
    this._maxHeight = document.body.clientHeight - topHeight;
    if (this.gridWrapper?.nativeElement.clientHeight >= this._maxHeight) {
      this._scrollable = true;
    } else {
      this._scrollable = true;
    }
  }

    _edit() {
        this._pageState = PageState.EDIT;
    }

    _onStateChanges(e: any) {
        if (e === 'minimized') {
            this._layoutManager.removeOverlay();
        } else {
            this._layoutManager.applyOverly();
        }
    }

    ngOnDestroy() {
      if (this._permissionSub) this._permissionSub.unsubscribe();
      if (this._authrizationSub) this._authrizationSub.unsubscribe();
      this._layoutManager.removeOverlay();
    }

getAllPermissions() {
  if (this._permissionSub) this._permissionSub.unsubscribe();
  if (!this._permissionsList) {
    this._permissionSub = this._permissionService.getAllPermissions().subscribe({
      next: result => {
        if (result) {
          this._permissionsList = [...result.data];
        }
      }
    });
  }
}

isActionAvailable(pageid: number, operation: string): boolean {
  let RetVal: boolean = false;
  if (this._permissionsList) {
    let ex = this._permissionsList.find(d => d.pageId == pageid && d.operation == operation);
    RetVal = ex != undefined;
  }
  return RetVal;
}


    @HostListener('window:resize', ['$event'])
    onResize(event: any) {
        this._innerWidth = window.innerWidth;
        if (this._innerWidth > 450) {
            this._hiddenWindow = 'hidden';
            this._maximized = 'maximized';
        } else {
            this._hiddenWindow = '';
            this._maximized = 'default';
        }
        let windowSize = window.innerWidth;

        if (windowSize <= 991) {
            this._kendoTabStripPosition = 'top';
        } else {
            this._kendoTabStripPosition = 'left';
        }
    }

    _onTabSelect(e: any) {
      if (e.title == 'General') {
        this._loadAppRoleWithModuleId(1);
      } else if (e.title == 'Barcloud NG Stock') {
        this._loadAppRoleWithModuleId(2);
      } else if (e.title == 'Barcloud NG Asset') {
        this._loadAppRoleWithModuleId(3);
      }
      this._mobileMenuToggle();
    }

    _mobileMenuToggle() {
        let mobiletabstrip = this.navTrigger?.nativeElement?.querySelector('ul');
        mobiletabstrip?.classList.toggle('visibletab');
    }

    _onSave(e: any) {
        this.submit(e);
    }

    _onCancel() {
        this._closeForm();
    }

    _closeForm() {
        var closeComponent = {
          component: 'appRoles',
          isClosed: true
        };

        this._active = false;

        this._gridLayoutManagerService.setGridDataSubjects('appRoles');
        this.ngOnDestroy();
        this._sharedService.closeDialog.emit(closeComponent);
        this._sharedService.model = {};
    }

    _closeDialog(event: boolean) {
        this._isDialiog = event;
    }

    _enableOfflineModeChecked(ev: any) {
        const model = this._form.value;
        model.enableOnlineMode = false;
        model.enableOnlineModeSync = false;
        this._form.patchValue({
            enableOnlineMode: false,
            enableOnlineModeSync: false
        });
    }

    _enableOfflineModeWithAuthChecked(ev: any) {
        const model = this._form.value;
        model.enableOnlineMode = false;
        model.enableOnlineModeSync = false;
        this._form.patchValue({
            enableOnlineMode: false,
            enableOnlineModeSync: false
        });
    }

    _enableOnlineModeChecked(ev: any) {
        const model = this._form.value;
        model.enableOfflineMode = false;
        model.enableOfflineModeWithAuth = false;
        this._form.patchValue({
            enableOfflineMode: false,
            enableOfflineModeWithAuth: false
        });
    }

    _enableOnlineModeSyncChecked(ev: any) {
        const model = this._form.value;
        model.enableOfflineMode = false;
        model.enableOfflineModeWithAuth = false;
        this._form.patchValue({
            enableOfflineMode: false,
            enableOfflineModeWithAuth: false
        });
    }

    _refreshGroupedData() {
      const normalizeAndGroup = (data: any[], defaultSection: string): GroupResult[] => {
        if (!data || data.length === 0) return [];
        const validData = data.filter(item => item && (item.pageTitle || item.pageName));
        validData.forEach(item => {
          if (!item.sectionCategoryName || item.sectionCategoryName.trim() === '') {
            item.sectionCategoryName = defaultSection;
          }
        });
        const grouped = groupBy(validData, [{ field: 'sectionCategoryName' }]) as GroupResult[];
        return grouped.filter(g => g && g.items && g.items.length > 0);
      };

      this._generalGroupedData = normalizeAndGroup(this._generalSecurityLevelsStockGridData, 'Files');
      this._stockGroupedData = normalizeAndGroup(this._stockSecurityLevelsStockGridData, 'General');
      this._assetGroupedData = normalizeAndGroup(this._AssetsSecurityLevelsStockGridData, 'General');
    }

    private _initForm() {
        this._form = this._fb.group({
            name: [this._model ? this._model.name : null, Validators.required],
            description: [this._model ? this._model.description : false],
            baseAppRole: [null]
        });

        if (this._pageState == PageState.ADD) {
            this._appRolesService.getAppRolesListing()
                .subscribe((data: any) => {
                    this._appRoles = data;
                    this._appRolesFiltered = data;
                    //load admin security levels
                    this._selectedAppRole.setValue(this._appRolesFiltered.filter(x => x.id == 2)[0]);
                    this._form.patchValue({
                        baseAppRole: this._appRolesFiltered.filter(x => x.id == 2)[0]
                    });
                    this._getAllRoles(2);
                });
        }
        if (this._pageState == PageState.EDIT || this._pageState == PageState.VIEW) {
          this._getAllRoles(this._model.id);
        }
        this.getAllPermissions();
    }

    _getAllRoles(id: number) {
      if (this._authrizationSub) this._authrizationSub.unsubscribe();
      this._authrizationSub = forkJoin([
        this._appRolesService.getAppRolePagePermissions(id, 1),
        this._appRolesService.getAppRolePagePermissions(id, 2),
        this._appRolesService.getAppRolePagePermissions(id, 3)
      ]).subscribe(([mod1, mod2, mod3]) => {
          this._generalSecurityLevelsStockGridData = mod1;
          this._stockSecurityLevelsStockGridData = mod2;
          this._AssetsSecurityLevelsStockGridData = mod3;
          this._refreshGroupedData();
      });
    }

    _handleAppRolesFilter(value: any) {
        this._appRolesFiltered = this._appRoles.filter(
            (s) => s.name.toLowerCase().indexOf(value.toLowerCase()) !== -1
        );
    }

    _handleAppRolesChange(value: any) {
        this._loadAppRoleSecurityLevels(value.id);
    }

    _loadAppRoleSecurityLevels(appRoleId: number) {
        this.appRoleId = appRoleId;
        if (this._authrizationSub) this._authrizationSub.unsubscribe();
        this._authrizationSub = forkJoin([
          this._appRolesService.getAppRolePagePermissions(appRoleId, 1),
          this._appRolesService.getAppRolePagePermissions(appRoleId, 2),
          this._appRolesService.getAppRolePagePermissions(appRoleId, 3)
        ]).subscribe(([mod1, mod2, mod3]) => {
            this._generalSecurityLevelsStockGridData = mod1;
            this._stockSecurityLevelsStockGridData = mod2;
            this._AssetsSecurityLevelsStockGridData = mod3;
            this._refreshGroupedData();
        });
    }

    _loadAppRoleWithModuleId(moduleId: number) {
        this.moduleId = moduleId;
        this._appRolesService.getAppRolePagePermissions(this.appRoleId, moduleId)
            .subscribe((data: any) => {
              if (data != null) {
                    if (this.moduleId == 1 && this._generalSecurityLevelsStockGridData.length == 0) {
                        this._generalSecurityLevelsStockGridData = data;
                    } else if (this.moduleId == 2 && this._stockSecurityLevelsStockGridData.length == 0) {
                        this._stockSecurityLevelsStockGridData = data;
                    } else if (this.moduleId == 3 && this._AssetsSecurityLevelsStockGridData.length == 0) {
                        this._AssetsSecurityLevelsStockGridData = data;
                    }
                    this._refreshGroupedData();
                }
            });
    }

    _securityChanged(grid: string, canWhat: string, pageId: number) {
        var currentLineItem: any;
        if (grid == 'general') {
            currentLineItem = this._generalSecurityLevelsStockGridData.find(x => x.pageId == pageId);
        } else if (grid == 'Barcloud NG Stock') {
            currentLineItem = this._stockSecurityLevelsStockGridData.find(x => x.pageId == pageId);
        }
        else if (grid == 'Barcloud NG Asset') {
            currentLineItem = this._AssetsSecurityLevelsStockGridData.find(x => x.pageId == pageId);
        }
        if (!currentLineItem) {
            return;
        }
        switch (canWhat) {
            case 'canView':
                currentLineItem.canView = !currentLineItem.canView;
                currentLineItem.defaultCanView = currentLineItem.canView;
                if (!currentLineItem.canView) {
                  currentLineItem.canAdd = false;
                  currentLineItem.canEdit = false;
                  currentLineItem.canDelete = false;
                  currentLineItem.defaultCanAdd = false;
                  currentLineItem.defaultCanEdit = false;
                  currentLineItem.defaultCanDelete = false;
                }
                break;
            case 'canAdd':
                currentLineItem.canAdd = !currentLineItem.canAdd;
                currentLineItem.defaultCanAdd = currentLineItem.canAdd;
                if (currentLineItem.canAdd) {
                  currentLineItem.canView = true;
                  currentLineItem.defaultCanView = true;
                } else if (currentLineItem.pageId && !this.isActionAvailable(currentLineItem.pageId, 'read')) {
                  currentLineItem.canView = false;
                  currentLineItem.defaultCanView = false;
                }
                break;
            case 'canEdit':
                currentLineItem.canEdit = !currentLineItem.canEdit;
                currentLineItem.defaultCanEdit = currentLineItem.canEdit;
                if (currentLineItem.canEdit) {
                  currentLineItem.canView = true;
                  currentLineItem.defaultCanView = true;
                }
                break;
            case 'canDelete':
                currentLineItem.canDelete = !currentLineItem.canDelete;
                currentLineItem.defaultCanDelete = currentLineItem.canDelete;
                if (currentLineItem.canDelete) {
                  currentLineItem.canView = true;
                  currentLineItem.defaultCanView = true;
                }
                break;
        }
    }

    private submit = (e: any) => {
        if (this._form.invalid) {
            this._invalidForm = true;
        } else {
            this._invalidForm = false;

            const model = this._form.value;

            const pagePermissions = (this._generalSecurityLevelsStockGridData || [])
                .concat(this._stockSecurityLevelsStockGridData || [])
                .concat(this._AssetsSecurityLevelsStockGridData || []);

            const clonedPagePermissions: any[] = [];
            pagePermissions.forEach(val => clonedPagePermissions.push(Object.assign({}, val)));

            model['pagePermissions'] = clonedPagePermissions;
            if (this._pageState == PageState.EDIT || this._pageState == PageState.VIEW) {
                this._appRolesService
                    .updateAppRole(this._model.id, model)
                    .subscribe((response: any) => {
                        if (response != null && response['message'] != null) {
                            this._layoutComponent.openPopup({
                                title: 'Alert',
                                message: response['message'],
                                withoutConfirm: true
                            });
                            if (response['message'] == 'Updated Successfully') {
                              if (e === 'saveAndClose') {
                                model.id = this._model.id;
                                this._closeForm();
                              } else if (e === 'saveAndCopy') {
                                this._form.controls.name.setValue(null);
                                this._form.controls.description.setValue(null);
                                this._pageState = PageState.ADD;
                              } else if (e === 'saveAndNew') {
                                this._pageState = PageState.ADD;
                                this._initForm();
                              }
                              else {
                                this._model.id = response.responseId;
                                this._pageState = PageState.EDIT;
                              }
                            } else {
                              return false;
                            }
                        }
                    });
            } else {
                this._appRolesService
                    .createAppRole(model)
                    .subscribe((response: any) => {
                        if (response != null && response['message'] != null) {
                            this._layoutComponent.openPopup({
                                title: 'Alert',
                                message: response['message'],
                                withoutConfirm: true
                            });
                            if (e === 'saveAndClose') {
                              model.id = this._model.id;
                              this._closeForm();
                            } else if (e === 'saveAndCopy') {
                              this._form.controls.name.setValue(null);
                              this._form.controls.description.setValue(null);
                              this._pageState = PageState.ADD;
                            } else if (e === 'saveAndNew') {
                              this._pageState = PageState.ADD;
                              this._initForm();
                            }
                            else {
                              this._model.id = response.responseId;
                              this._pageState = PageState.EDIT;
                            }
                        }
                    });
            }
        }
    }
}
